<template>
  <b-row class="justify-content-center">
    <b-col v-if="fetchingProfileInformation || fetchingUser">
      <loading-page />
    </b-col>
    <b-col
      v-else
      cols="12"
      lg="8"
    >
      <div class="d-flex align-items-center">
        <div v-if="!organizationId || !projectId">
          <b-button
            variant="icon-light"
            class="shadow"
            @click="goBack"
          >
            <GjIcon name="ArrowLeft" />
            Back
          </b-button>
        </div>
        <div class="powered-by d-flex align-items-center ml-auto mb-2 mt-1">
          <span class="text-secondary mr-1 text-xsm">
            powered by
          </span>
          <img
            :src="require('@/assets/images/logo/porta-logo.png')"
            alt="PortaLogo"
            class="porta-lo"
          >
        </div>
      </div>
      <paper-simple body-class="py-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="px-2 d-flex align-items-center">
            <div>
              <div
                class="rounded-full profile_image"
                :style="
                  profileInformation.picture
                    ? `background-image:url(${profileInformation.picture})`
                    : ''
                "
              />
            </div>
            <h5 class="name mb-0 ml-2">
              {{ profileInformation.firstName }}
              {{ profileInformation.lastName }}
            </h5>
            <b-spinner
              v-if="fetchingProfileInformation"
              small
              class="ml-2"
            />
          </div>
          <div class="d-none d-md-flex align-items-center">
            <b-button
              variant="bg-white"
              class="ml-1 mb-sm-0 mb-1"
              @click="showProfilePictureModal = true"
            >
              <GjIcon
                name="Image"
                class="icon-left"
              />
              Change Profile Picture
            </b-button>
            <b-button
              variant="bg-white"
              class="ml-1 mb-sm-0 mb-1"
              :to="{ name: 'update-profile' }"
            >
              <GjIcon
                name="Edit"
                class="icon-left"
              />
              Update Info
            </b-button>
          </div>
          <b-dropdown
            ref="dropdown"
            class="d-md-none"
            right
            variant="transparent"
            no-caret
          >
            <template #button-content>
              <GjIcon
                name="Moreoptions"
                class="m-0"
                size="24"
              />
            </template>
            <b-dropdown-item @click="showProfilePictureModal = true">
              <GjIcon
                name="Image"
                class="icon-left"
              /> Change Profile Picture
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item :to="{ name: 'update-profile' }">
              <GjIcon
                name="Edit"
                class="icon-left"
              /> Update Info
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </paper-simple>
      <paper-simple body-class="pb-0">
        <div class="px-2">
          <b-row>
            <b-col>
              <input-field
                name="profile-email"
                label="Email"
                label-position="top"
                info-position="label"
              >
                {{ profileInformation.email || '-' }}
              </input-field>
            </b-col>
            <b-col>
              <input-field
                name="profile-number"
                label="Phone number"
                label-position="top"
                info-position="label"
              >
                <a
                  :href="
                    profileInformation.phoneNumber
                      ? `tel:${profileInformation.phoneNumber}`
                      : ''
                  "
                >
                  {{ profileInformation.phoneNumber || '-' }}
                  <b-icon-telephone-outbound-fill
                    v-if="profileInformation.phoneNumber"
                    aria-hidden="true"
                  />
                </a>
              </input-field>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <input-field
                name="profile-gender"
                label="Gender"
                label-position="top"
                info-position="label"
              >
                <span class="text-capitalize">
                  {{ profileInformation.gender || '-' }}
                </span>
              </input-field>
            </b-col>
            <b-col>
              <input-field
                name="profile-birthday"
                label="Birthday"
                label-position="top"
                info-position="label"
              >
                {{ profileInformation.birthdate || '-' }}
              </input-field>
            </b-col>
          </b-row>
        </div>
      </paper-simple>
      <paper-simple body-class="pb-0">
        <div class="px-2">
          <b-row>
            <b-col>
              <input-field
                name="profile-default_organization"
                label="Default Organization"
                label-position="top"
                info-position="label"
              >
                <span
                  v-if="user.defaultOrganizationId"
                  class="mr-1"
                >
                  {{ user.defaultOrganizationName || '-' }}
                </span>
                <a
                  class="text-sm text-primary"
                  @click="showDefaultOrganizationModal = true"
                >
                  {{ user.defaultOrganizationId ? 'Change' : 'Select' }}
                </a>
              </input-field>
            </b-col>
            <b-col>
              <input-field
                name="profile-default_project"
                label="Default Project"
                label-position="top"
                info-position="label"
              >
                <span
                  v-if="user.defaultProjectId"
                  class="mr-1"
                >
                  {{ user.defaultProjectName || '-' }}
                </span>
                <a
                  v-if="user.defaultOrganizationId"
                  class="text-sm text-primary"
                  @click="showDefaultProjectModal = true"
                >
                  {{ user.defaultProjectId ? 'Change' : 'Select' }}
                </a>
                <span
                  v-else
                  class="text-secondary"
                >
                  No default project
                </span>
              </input-field>
            </b-col>
          </b-row>
        </div>
      </paper-simple>
      <paper-simple body-class="pb-0">
        <div class="px-2">
          <input-field
            name="profile-security"
            label="Security"
            label-position="top"
            info-position="label"
          >
            <a
              class="porta-link align-items-center d-flex "
              @click="goTo('security')"
            >
              <span>
                Your password and 2FA
              </span>
              <GjIcon
                name="Redirect"
                size="17"
              />
            </a>
          </input-field>
          <input-field
            name="profile-external_logins"
            label="External logins"
            label-position="top"
            info-position="label"
          >
            <a
              class="porta-link align-items-center d-flex "
              @click="goTo('external-logins')"
            >
              <span>
                Manage your log in services
              </span>
              <GjIcon
                name="Redirect"
                size="17"
              />
            </a>
            <a
              class="porta-link"
              @click="goTo('personalization')"
            />
          </input-field>
          <input-field
            name="profile-external_logins"
            label="Data & Personalization"
            label-position="top"
            info-position="label"
          >
            <a
              class="porta-link align-items-center d-flex "
              @click="goTo('security')"
            >
              <span>
                Download or delete your data
              </span>
              <GjIcon
                name="Redirect"
                size="17"
              />
            </a>
          </input-field>
        </div>
      </paper-simple>
    </b-col>
    <profile-picture
      v-if="profileInformation"
      v-model="showProfilePictureModal"
      :url="profileInformation.picture"
      @refresh="fetchProfileInformation"
    />
    <default-organization
      v-model="showDefaultOrganizationModal"
      @defaultSet="
        () => {
          fetchUser()
          showDefaultOrganizationModal = false
        }
      "
    />
    <default-project
      v-model="showDefaultProjectModal"
      @defaultSet="
        () => {
          fetchUser()
          showDefaultProjectModal = false
        }
      "
    />
  </b-row>
</template>

<script>
import ProfilePicture from './ProfilePicture.vue'
import DefaultOrganization from './user-defaults/DefaultOrganization.vue'
import DefaultProject from './user-defaults/DefaultProject.vue'
import { BIconTelephoneOutboundFill } from 'bootstrap-vue'

export default {
  name: 'Profile',
  components: {
    ProfilePicture,
    DefaultOrganization,
    DefaultProject,
    BIconTelephoneOutboundFill,
  },
  data() {
    return {
      test: '',
      userInformation: null,
      showProfilePictureModal: false,
      showDefaultOrganizationModal: false,
      showDefaultProjectModal: false,
    }
  },
  computed: {
    profileInformation() {
      return this.$store.state.profile.profileInformation
    },
    fetchingProfileInformation() {
      return this.$store.state.profile.fetchingProfileInformation
    },
    user() {
      return this.$store.state.users.user
    },
    fetchingUser() {
      return this.$store.state.users.fetchingUser
    },
    projectId() {
      return this.$store.state.app.projectId
    },
    organizationId() {
      return this.$store.state.app.organizationId
    },
  },
  created() {
    if (this.$route.params.toast) {
      const { toast } = this.$route.params
      this.generalToast(toast.message, toast.title, toast.variant)
    }
    this.fetchProfileInformation()
    this.fetchUser()
  },
  methods: {
    fetchProfileInformation() {
      this.$store.dispatch('profile/fetchProfileInformation').catch(error => {
        this.errorToast(
          error.response?.data?.errors[0]
            || 'Something went wrong while fetching profile information.',
        )
      })
    },
    fetchUser() {
      this.$store.dispatch('users/fetchUser').catch(error => {
        this.errorToast(
          error.response?.data?.errors[0]
            || 'Something went wrong while fetching user.',
        )
      })
    },
    goTo(path) {
      window.open(`${process.env.VUE_APP_PROFILE_URL}${path}`, '_blank').focus()
    },
    goBack() {
      if (!this.organizationId) {
        this.$router.push({ name: 'organization', query: this.$route.query })
        return
      }
      this.$router.push({ name: 'project', params: { projectId: null } })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';

.porta-link {
  color: $primary;
  span {
    margin-right: 5px;
  }
}

.profile_image {
  background-color: $white-300;
  width: 73px;
  height: 73px;
  border-radius: 100%;
  background-size: cover;
  border: 1px solid $gray-100;
}
.name {
  color: $blue-700;
}
.powered-by {
  img {
    width: 80px;
  }
}
a[href=''] {
  cursor: default;
  pointer-events: none;
}
</style>
